import { useCallback, type ReactNode } from 'react';
import {
  useHtmlToReact,
  type ElementTransform,
} from '@/components/Common/HtmlToReact';
import { ApprovalFormTable } from '@/components/Approval/@components/ApprovalFormTable';
import { SapCollateralChangeRoot } from './styles';

export { buildSapCollateralChangeContentHtml } from './content';

const DROP_TAGS = new Set(['style', 'script', 'link', 'input', 'button']);
const TABLE_PARTS = new Set([
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'colgroup',
]);
const isBlankText = (node: ReactNode) =>
  typeof node === 'string' && !node.trim();

/** 저장 content(레거시 문서 포함) 그대로 — 표만 공통 양식 표로 */
export const SapCollateralChangeSnapshot = ({
  content,
}: {
  content: string;
}) => {
  const transform = useCallback<ElementTransform>(
    ({ tagName, props, children }) => {
      if (DROP_TAGS.has(tagName)) return null;
      if (TABLE_PARTS.has(tagName)) {
        const kept = children.filter((c) => !isBlankText(c));
        children.splice(0, children.length, ...kept);
      }
      if (tagName === 'table') {
        return (
          <ApprovalFormTable key={props.key as string}>
            {children}
          </ApprovalFormTable>
        );
      }
      return undefined;
    },
    [],
  );
  const rendered = useHtmlToReact(content, { transform });
  return <SapCollateralChangeRoot>{rendered}</SapCollateralChangeRoot>;
};
